// extracted by mini-css-extract-plugin
module.exports = {"box":"form_box__3RH0O"};